import {object, string} from 'yup';

import {$BankAccountData} from './$BankAccountData';

export const $BankAccountRequestBody = object({
  bankAccountData: $BankAccountData,
  id: string().defined().nullable(),
});
